interface ILogger {
  log: (...args: any[]) => void;
  info: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  error: (...args: any[]) => void;
  debug: (...args: any[]) => void;
}

class Logger implements ILogger {
  private isEnabled: boolean;

  constructor() {
    // 从环境变量获取配置，默认在生产环境禁用日志
    this.isEnabled = process.env.REACT_APP_ENABLE_LOGS === "true" || process.env.NODE_ENV === "development";
  }

  private formatMessage(type: string, args: any[]): any[] {
    const timestamp = new Date().toISOString();
    return [`[${timestamp}][${type}]`, ...args];
  }

  log(...args: any[]): void {
    if (this.isEnabled) {
      console.log(...this.formatMessage("LOG", args));
    }
  }

  info(...args: any[]): void {
    if (this.isEnabled) {
      console.info(...this.formatMessage("INFO", args));
    }
  }

  warn(...args: any[]): void {
    if (this.isEnabled) {
      console.warn(...this.formatMessage("WARN", args));
    }
  }

  error(...args: any[]): void {
    // 错误日志始终显示，因为这对调试问题很重要
    console.error(...this.formatMessage("ERROR", args));
  }

  debug(...args: any[]): void {
    if (this.isEnabled) {
      console.log(...this.formatMessage("DEBUG", args));
    }
  }
}

const logger = new Logger();
export default logger;
